/* tslint:disable */
/* eslint-disable */
/**
 * lq.api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RiskScoreQualitativeScore,
    RiskScoreQualitativeScoreFromJSON,
    RiskScoreQualitativeScoreFromJSONTyped,
    RiskScoreQualitativeScoreToJSON,
    RiskScoreRiskScoreName,
    RiskScoreRiskScoreNameFromJSON,
    RiskScoreRiskScoreNameFromJSONTyped,
    RiskScoreRiskScoreNameToJSON,
} from './';

/**
 * 
 * @export
 * @interface RiskScore
 */
export interface RiskScore {
    /**
     * 
     * @type {string}
     * @memberof RiskScore
     */
    quantitativeScore?: string | null;
    /**
     * 
     * @type {Array<RiskScoreRiskScoreName>}
     * @memberof RiskScore
     */
    riskScoreName?: Array<RiskScoreRiskScoreName> | null;
    /**
     * 
     * @type {Array<RiskScoreQualitativeScore>}
     * @memberof RiskScore
     */
    qualitativeScore?: Array<RiskScoreQualitativeScore> | null;
}

export function RiskScoreFromJSON(json: any): RiskScore {
    return RiskScoreFromJSONTyped(json, false);
}

export function RiskScoreFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskScore {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'quantitativeScore': !exists(json, 'quantitativeScore') ? undefined : json['quantitativeScore'],
        'riskScoreName': !exists(json, 'riskScoreName') ? undefined : (json['riskScoreName'] === null ? null : (json['riskScoreName'] as Array<any>).map(RiskScoreRiskScoreNameFromJSON)),
        'qualitativeScore': !exists(json, 'qualitativeScore') ? undefined : (json['qualitativeScore'] === null ? null : (json['qualitativeScore'] as Array<any>).map(RiskScoreQualitativeScoreFromJSON)),
    };
}

export function RiskScoreToJSON(value?: RiskScore | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'quantitativeScore': value.quantitativeScore,
        'riskScoreName': value.riskScoreName === undefined ? undefined : (value.riskScoreName === null ? null : (value.riskScoreName as Array<any>).map(RiskScoreRiskScoreNameToJSON)),
        'qualitativeScore': value.qualitativeScore === undefined ? undefined : (value.qualitativeScore === null ? null : (value.qualitativeScore as Array<any>).map(RiskScoreQualitativeScoreToJSON)),
    };
}


